import { getInnerProps } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    position: {
      type: Object,
      required: true,
    },
    action: {
      type: String,
      required: false,
    },
  },
  computed: {
    dropmenuStyle() {
      return {
        left: `${this.position.left}px`,
        top: `${this.position.top}px`,
      };
    },
    innerShow: getInnerProps('show'),
  },
  methods: {
    onClickOutside() {
      if (this.show && this.action !== 'dropmenu') {
        this.innerShow = false;
      }
    },
    onEventActions(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.action) {
        target = target.parentNode;
      }
      const { action } = target.dataset;
      if (action) {
        this.$emit('on-action', action);
        this.innerShow = false;
      }
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
